export enum RoutesEnum {
    catchAll = '*',

    login = '/login',
    forgottenPassword = '/forgottenPassword',
    resetPassword = '/resetPassword/:token',

    dashboard = '/dashboard',

    chatWithChatGpt = '/chat/chat-gpt',
    chatWithClaude = '/chat/claude',
    chatWithMistral = '/chat/mistral',
    chatWithGemini = '/chat/gemini',
    chatWithOpenRouter = '/chat/openrouter',
    chatWithCustomEndpoint = '/chat/custom/:publicId',

    ocr = '/ocr',

    userList = '/user/list',
    userCreate = '/user/create',
    userDetail = '/user/:userId/detail',
    userEdit = '/user/:userId/edit',
    userDelete = '/user/:userId/delete',
    userTokenUsage = '/user/:userId/token-usage',

    companyList = '/company/list',
    companyCreate = '/company/create',
    companyDetail = '/company/:companyId/detail',
    companyEdit = '/company/:companyId/edit',
    companyDelete = '/company/:companyId/delete',
    companyListUsers = '/company/:companyId/users',

    customEndpointList = '/custom-endpoints',
    customEndpointCreate = '/custom-endpoints/create',
    customEndpointDetail = '/custom-endpoints/:endpointId/detail',
    customEndpointEdit = '/custom-endpoints/:endpointId/edit',
    customEndpointDelete = '/custom-endpoints/:endpointId/delete',
}

export enum RoutesParametersEnum {
    userId = ':userId',
    companyId = ':companyId',
    endpointId = ':endpointId',
    publicId = ':publicId',
}
